import { Text, utils as coreUtils } from '@adc/ui-core'
import _cx from 'classnames/bind'
import cls from '../styles.scss'
import React from 'react'
import { MatchBidCosts } from '../costs'
import PropTypes from 'prop-types'
const cx = _cx.bind(cls)

const MatchBidContent = ({
  bidAmount,
  currentUserBidAmount,
  buyersPremium,
  totalPurchasePrice,
  earnestMoneyDeposit,
}) => {
  return (
    <>
      <div className={cx('bid-pill-container')}>
        <div className={cx('bid-pill')} data-elm-id='amount_to_bid'>
          <span>Match Winning Bid: </span>
          <span>{coreUtils.formatters.formatMoney(bidAmount)}</span>
        </div>
      </div>
      <MatchBidCosts
        currentBidAmount={bidAmount}
        currentUserBidAmount={currentUserBidAmount}
        buyersPremium={buyersPremium}
        totalPurchasePrice={totalPurchasePrice}
        earnestMoneyDeposit={earnestMoneyDeposit}
      />
      <Text className={cx('u-mb-2', 'u-mt-2')} size='tiny' color='gray'>
        To match winning bid, you will need to select a Purchase Profile.
      </Text>
    </>
  )
}

MatchBidContent.propTypes = {
  bidAmount: PropTypes.number.isRequired,
  currentUserBidAmount: PropTypes.number,
  buyersPremium: PropTypes.number.isRequired,
  totalPurchasePrice: PropTypes.number.isRequired,
  earnestMoneyDeposit: PropTypes.number.isRequired,
}
export default MatchBidContent
